import { render, staticRenderFns } from "./AsiAlert.vue?vue&type=template&id=259ca5ef&scoped=true"
import script from "./AsiAlert.vue?vue&type=script&lang=ts"
export * from "./AsiAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ca5ef",
  null
  
)

export default component.exports